import { arrayExistDuplicate } from "../../functions/arrays";
import { ceduleValidate } from "../../functions/validators";
export const validateIdentificationPayroll = (data, dataFilter, i) => {
    try {
        // console.log('validando ', data, dataFilter, i)
        switch (data.TipoIdentificacion) {
            case 1:
                //  console.log('valida cedula', ceduleValidate('cedula', data.Identificacion))
                const vCedule = ceduleValidate('cedula', data.Identificacion)
                if (vCedule.status === 'ERROR')
                    dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? `, ${vCedule.message.toUpperCase()}`: 'CEDULA NO VALIDA'}`
                break;
            case 2:
                const vRuc = ceduleValidate('ruc', data.Identificacion)
                if (vRuc.status === 'ERROR')
                    dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? `, ${vRuc.message.toUpperCase()}`: 'CEDULA NO VALIDA'}`
                break;
            default:
                break;
        }
    } catch (error) {
        //console.log(error)
    }
}

export const validatePayroll = (dataFilter, setDocumentIsCorrect) => {
    try {
        //  console.log('validatePayroll', dataFilter)
        const accountDuplicate = arrayExistDuplicate(dataFilter, 'NumeroCuentaDestino')
        const identificacionDuplicate = arrayExistDuplicate(dataFilter, 'Identificacion')
        dataFilter.forEach((data, i) => {
            dataFilter[i].validate =''
            // dataFilter[i].validate = 'CORRECTO'
            if(parseFloat(data.Valor)<= 0) {
                dataFilter[i].validate = dataFilter[i].validate + ' NO SE PERMITE MONTO EN 0'
                setDocumentIsCorrect(false)
            }

            if (isNaN(parseFloat(data.Valor))) {
                dataFilter[i].validate = dataFilter[i].validate + ' EL MONTO DEBE SER NUMERICO'
                setDocumentIsCorrect(false)
            }

            if (isNaN(data.NumeroCuentaDestino)) {
                dataFilter[i].validate = dataFilter[i].validate + ' EL NUMERO DE CUENTA DEBE SER NUMERICO'
                setDocumentIsCorrect(false)
            }

            if (data.Identificacion === 'Identificacion' || data.TipoIdentificacion === 'TipoIdentificacion' || data.NombreApellido === 'NombreApellido' ||
            data.NumeroCuentaDestino === 'NumeroCuentaDestino' || data.TipoCuenta === 'TipoCuenta' || data.Valor === 'Valor' || data.Institucion === 'Institucion' ||
            data.InstitucionNumero ==='InstitucionNumero' || data.InstitucionCodigo === 'InstitucionCodigo') {
                dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? ', DATOS INCORRECTOS': 'DATOS INCORRECTOS'}`
                setDocumentIsCorrect(false)
            }
            if (accountDuplicate.length > 0) {
                accountDuplicate.forEach(acc => {
                    if (acc.fieldData === data.NumeroCuentaDestino) {
                        dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? ', CUENTA DUPLICADA': 'CUENTA DUPLICADA'}`
                        setDocumentIsCorrect(false)
                    }
                });
            }
            if (identificacionDuplicate.length > 0) {
                identificacionDuplicate.forEach(acc => {
                    if (acc.fieldData === data.Identificacion) {
                        dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? ', IDENTIFICACION DUPLICADA': 'IDENTIFICACION DUPLICADA'}`
                        setDocumentIsCorrect(false)
                    }
                });
            }
            validateIdentificationPayroll(data, dataFilter, i)
            // switch (data.TipoIdentificacion) {
            //     case 'CEDULA':
            //         //  console.log('valida cedula', ceduleValidate('cedula', data.Identificacion))
            //         const vCedule = ceduleValidate('cedula', data.Identificacion)
            //         if (vCedule.status === 'ERROR')
            //             dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? `, ${vCedule.message.toUpperCase()}`: 'CEDULA NO VALIDA'}`
            //         break;
            //     case 'RUC':
            //         const vRuc = ceduleValidate('ruc', data.Identificacion)
            //         if (vRuc.status === 'ERROR')
            //             dataFilter[i].validate = dataFilter[i].validate + `${dataFilter[i].validate !== ''? `, ${vRuc.message.toUpperCase()}`: 'CEDULA NO VALIDA'}`
            //         break;
            //     default:
            //         break;
            // }
            if (dataFilter[i].validate === '') { dataFilter[i].validate = 'CORRECTO' } else { setDocumentIsCorrect(false)}
        });
    } catch (error) {
        // console.log(error)
    }
}